<div class="flex items-center ps-2 mb-4 relative" [ngClass]="isCollapsed ? 'justify-start' : 'justify-between'">

  <!-- Circle with C (only when sidebar is collapsed and not hovering over X) -->
  <span
    class="font-sans not-italic text-3xl bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center transition-opacity duration-200"
    [ngClass]="{
      'opacity-100': (isCollapsed && !hover)||!isCollapsed,
      'opacity-0': !isCollapsed || hover
    }">
    <div class="-translate-x-1">𝒞</div>
  </span>

  <!-- Toggle button X -->
  <button (click)="toggleSidebar()" class="p-1 absolute right-0 transition-opacity duration-200" [ngClass]="{
            'opacity-100': !isCollapsed || hover,
            'opacity-0': isCollapsed && !hover
          }" (mouseenter)="hover = true" (mouseleave)="hover = false">
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f">
      <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
    </svg>
  </button>

</div>


<!-- Full width border under the flex container -->
<div class="border-b-1 border-gray-300 w-full"></div>

<nav [class.collapsed]="isCollapsed"
  class="flex flex-col gap-1 no-card relative border-none no-sidebar-border transition-all duration-200 h-full"
  role="navigation">

  <div class="nav-link w-full border-none">
    <ul class="max-h-[calc(100dvh-200px)] overflow-auto border-none mt-3"
      [ngClass]="isCollapsed ? 'flex flex-col items-end pr-2' : ''">

      @for (item of menu; track $index ; let i = $index) {
      <li *ngIf="!(isCollapsed && item.label === 'Chats')" class="mb-1 border-none relative w-full">
        <a [routerLink]="item.path" routerLinkActive="bg-gray-100 text-gray-800 font-medium" (click)="toggleSubmenu(item,i)"
          [ngClass]="{
            
      'flex items-center py-2 rounded-lg transition group w-full': true,
      'justify-center px-0': isCollapsed,
      'px-3 pr-4': !isCollapsed,
      'hover:bg-gray-200 hover:text-gray-700': item.isSpecial,
      'hover:bg-linear-to-r hover:from-primary-dark hover:to-primary': !item.isSpecial
   }" [class.justify-center]="isCollapsed" [class.px-3]="!isCollapsed" [class.px-0]="isCollapsed"
          [class.w-full]="true">
          <span [ngClass]="{
    'flex items-center ml-1': isCollapsed, 
    ' flex items-center ': !isCollapsed
  }">
            @switch (item.icon) {
            @case ('User') {
            <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1251_98416)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M9 0C5.96243 0 3.5 2.46243 3.5 5.5C3.5 8.53757 5.96243 11 9 11C12.0376 11 14.5 8.53757 14.5 5.5C14.5 2.46243 12.0376 0 9 0ZM5.5 5.5C5.5 3.567 7.067 2 9 2C10.933 2 12.5 3.567 12.5 5.5C12.5 7.433 10.933 9 9 9C7.067 9 5.5 7.433 5.5 5.5Z"
                  fill="#000000" />
                <path
                  d="M15.5 0C14.9477 0 14.5 0.447715 14.5 1C14.5 1.55228 14.9477 2 15.5 2C17.433 2 19 3.567 19 5.5C19 7.433 17.433 9 15.5 9C14.9477 9 14.5 9.44771 14.5 10C14.5 10.5523 14.9477 11 15.5 11C18.5376 11 21 8.53757 21 5.5C21 2.46243 18.5376 0 15.5 0Z"
                  fill="#000000" />
                <path
                  d="M19.0837 14.0157C19.3048 13.5096 19.8943 13.2786 20.4004 13.4997C22.5174 14.4246 24 16.538 24 19V21C24 21.5523 23.5523 22 23 22C22.4477 22 22 21.5523 22 21V19C22 17.3613 21.0145 15.9505 19.5996 15.3324C19.0935 15.1113 18.8625 14.5217 19.0837 14.0157Z"
                  fill="#000000" />
                <path
                  d="M6 13C2.68629 13 0 15.6863 0 19V21C0 21.5523 0.447715 22 1 22C1.55228 22 2 21.5523 2 21V19C2 16.7909 3.79086 15 6 15H12C14.2091 15 16 16.7909 16 19V21C16 21.5523 16.4477 22 17 22C17.5523 22 18 21.5523 18 21V19C18 15.6863 15.3137 13 12 13H6Z"
                  fill="#000000" />
              </g>
              <defs>
                <clipPath id="clip0_1251_98416">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            }
            @case ('Meeting') {
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 -960 960 960" fill="#1f1f1f">
              <path
                d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z" />
            </svg>
            }
            @case('meeting-bot'){
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.47588 15.0377C9.34573 15.0377 10.0509 14.3325 10.0509 13.4627C10.0509 12.5928 9.34573 11.8877 8.47588 11.8877C7.60603 11.8877 6.90088 12.5928 6.90088 13.4627C6.90088 14.3325 7.60603 15.0377 8.47588 15.0377Z"
                fill="#111928" />
              <path
                d="M15.5262 15.0377C16.396 15.0377 17.1012 14.3325 17.1012 13.4627C17.1012 12.5928 16.396 11.8877 15.5262 11.8877C14.6563 11.8877 13.9512 12.5928 13.9512 13.4627C13.9512 14.3325 14.6563 15.0377 15.5262 15.0377Z"
                fill="#111928" />
              <path
                d="M12.0012 19.1999C13.7262 19.1999 14.9637 18.7874 15.7512 18.0374C15.9012 17.8874 15.9012 17.5499 15.7512 17.3999C15.6012 17.2499 15.2637 17.2499 15.1137 17.3999C14.5512 18.0374 13.5012 18.2999 12.0012 18.2999C10.5012 18.2999 9.48867 17.9999 8.88867 17.3999C8.73867 17.2499 8.40117 17.2499 8.25117 17.3999C8.10117 17.5499 8.10117 17.8874 8.25117 18.0374C9.03867 18.8249 10.2762 19.1999 12.0012 19.1999Z"
                fill="#111928" />
              <path
                d="M17.1381 20.7375C17.8881 20.4375 18.6006 20.1 19.2381 19.6875C21.2256 18.375 22.3506 16.575 22.3506 14.7375C22.3506 14.475 22.3131 14.2125 22.3131 13.9875C23.0631 13.5 23.6256 12.675 23.6256 11.7375C23.6256 10.275 22.4256 9.1125 21.0006 9.1125C20.3631 9.1125 19.6881 9.375 19.2756 9.75C17.4756 8.5875 15.1881 7.95 12.7131 7.875L14.0631 3.5625L17.7381 4.4625C17.7381 5.6625 18.7506 6.6375 19.9131 6.6375C21.0756 6.6375 22.0881 5.625 22.0881 4.4625C22.0881 3.3 21.0381 2.25 19.8756 2.25C18.9756 2.25 18.1881 2.775 17.8881 3.5625L13.8006 2.7C13.5756 2.625 13.3131 2.7375 13.2756 3L11.7006 7.95C9.0756 7.9875 6.6381 8.7 4.7631 9.825C4.2756 9.4125 3.67559 9.1875 3.03809 9.1875C1.57559 9.1875 0.413086 10.3875 0.413086 11.8125C0.413086 12.75 0.938086 13.6125 1.72559 14.0625C1.68809 14.325 1.68809 14.5875 1.68809 14.8125C1.68809 16.6875 2.77559 18.45 4.8006 19.7625C5.4381 20.175 6.1131 20.5125 6.9006 20.8125C6.8631 20.7375 12.3006 22.9875 17.1381 20.7375ZM19.8756 3.1125C20.5506 3.1125 21.1881 3.675 21.1881 4.425C21.1881 5.1 20.6256 5.7375 19.8756 5.7375C19.2006 5.7375 18.5631 5.175 18.5631 4.425C18.5631 3.675 19.1631 3.1125 19.8756 3.1125ZM1.31309 11.7375C1.31309 10.8 2.06309 10.0125 3.03809 10.0125C3.41309 10.0125 3.7881 10.125 4.0506 10.3125C3.03809 11.1 2.32559 12.0375 1.95059 13.0875C1.53809 12.75 1.31309 12.2625 1.31309 11.7375ZM12.0006 20.775C6.7881 20.775 2.55059 18.0375 2.55059 14.775C2.55059 11.5125 6.7881 8.7375 12.0006 8.7375C17.2131 8.7375 21.4506 11.475 21.4506 14.7375C21.4506 18 17.2131 20.775 12.0006 20.775ZM22.0881 13.05C21.7131 12.0375 21.0006 11.1 19.9881 10.275C20.2881 10.05 20.6256 9.975 21.0006 9.975C21.9381 9.975 22.7256 10.725 22.7256 11.7C22.6881 12.2625 22.4631 12.75 22.0881 13.05Z"
                fill="#111928" />
            </svg>
            }
            @case('history')
            {
              <img src="img/history.png"/>
            }
            }
          </span>


          <!-- Label - hidden when collapsed -->
          @if (!isCollapsed) {
          <span class="block px-2 py-1 rounded-lg text-md transition truncate">
            {{ item.label }}
          </span>
          }
          <div *ngIf="isActive(item) && !isCollapsed"
            class="absolute top-2 bottom-2 right-3 w-1 bg-blue-600 rounded-full"></div>

          <!-- Tooltip (hover) - shown when collapsed -->
          @if (isCollapsed) {
          <span class="sidebar-tooltip" [attr.data-tooltip]="item.label"></span>
          }

          <!-- Dropdown arrow - hidden when collapsed -->
          @if (item.children && !isCollapsed) {
          <span class="ml-auto">
            <svg [class.rotate-90]="expandedIndex() === i" class="h-4 w-4 transition-transform" fill="none"
              stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </span>
          }

        </a>

        <!-- Submenu - only show when not collapsed -->
        @if (item.children && expandedIndex() === i && !isCollapsed) {
        <div class="border-none">
          <ul class="mt-1 rounded-2xl p-2 pt-0 ps-4 space-y-1 transition-all relative border-none">
            @for (child of item.children; track child) {
            <li class="border-none">
              <a [routerLink]="child.path"
                routerLinkActive="bg-linear-to-r from-primary-dark to-primary hover:from-primary hover:to-primary-dark transition-all duration-200 ease text-white font-semibold active"
                class="flex items-center gap-2 group px-3.5 ps-5 py-1 rounded-lg text-sm hover:bg-linear-to-r hover:from-primary-dark hover:to-primary hover:text-white border-none">
                {{ child.label }}
              </a>
            </li>
            }
          </ul>
        </div>
        }
        <button *ngIf="item.icon === 'search'" type="button" (click)="openSearchPopup()" class="flex items-center p-2 py-2 w-full rounded-lg transition group border-none hover:bg-gray-200 hover:text-gray-700
          [class.justify-center]='isCollapsed' [class.px-3]='!isCollapsed' [class.px-0]='isCollapsed'">

          <span [ngClass]="{ 'flex items-center ml-1': isCollapsed, 'flex items-center': !isCollapsed }">
            <svg [class]="isCollapsed ? 'w-5 h-5' : 'w-4 h-4'" viewBox="0 0 24 24" fill="none">
              <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2" />
              <path d="m21 21-4.35-4.35" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            @if (!isCollapsed) {
            <span class="block px-2 py-1 text-sm truncate">Search chats</span>
            }
          </span>
        </button>
      </li>
      }
    </ul>
  </div>
</nav>

<!-- Settings Section at Bottom -->
<div class="absolute bottom-4 left-0 right-0 px-2">
  <div class="relative">
    <button (click)="toggleSettingsMenu()" 
      class="settings-container flex items-center w-full py-2 rounded-lg transition hover:bg-gray-200"
      [ngClass]="{'justify-center px-0': isCollapsed, 'px-3': !isCollapsed}">
      <span class="flex items-center" [ngClass]="{'ml-1': isCollapsed}">
        <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#1f1f1f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke="#1f1f1f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      @if (!isCollapsed) {
        <span class="block px-2 py-1 text-md">Settings</span>
      }
      @if (isCollapsed) {
        <span class="sidebar-tooltip" data-tooltip="Settings"></span>
      }
    </button>

    <!-- Settings Dropdown Menu -->
    @if (showSettingsMenu()) {
      <div class="settings-container absolute bottom-full left-0 right-0 mb-2 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
        <button (click)="logout()" 
          class="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition">
          <svg class="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="#1f1f1f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 17L21 12L16 7" stroke="#1f1f1f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 12H9" stroke="#1f1f1f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Logout
        </button>
      </div>
    }
  </div>
</div>

@if (isCollapsed) {
<div class="fixed inset-0 pointer-events-none z-50" id="tooltip-container">

</div>
}